import _ from 'lodash';

type PlaceableColumn = {
    _id?: string;
    isSmart?: boolean;
    [key: string]: any;
};

export type PlaceableBoard = {
    _id?: string;
    name?: { fr?: string; en?: string; de?: string } | string;
    columns?: PlaceableColumn[];
    [key: string]: any;
};

type PlaceableProject = {
    posture?: { defaultLanding?: string };
    boards?: PlaceableBoard[];
    [key: string]: any;
};

export function prefersListLanding(project?: PlaceableProject | null): boolean {
    return project?.posture?.defaultLanding === 'list';
}

export function placeableBoardsOf(project?: PlaceableProject | null): PlaceableBoard[] {
    return (project?.boards || []).filter((board: PlaceableBoard) =>
        _.some(board.columns, (column: PlaceableColumn) => !column.isSmart)
    );
}

export function placeableColumnsOf(board?: PlaceableBoard | null): PlaceableColumn[] {
    return (board?.columns || []).filter((column: PlaceableColumn) => !column.isSmart);
}

/** Board picker is only relevant for kanban-default projects. */
export function shouldShowBoardPicker(project?: PlaceableProject | null): boolean {
    return !prefersListLanding(project);
}

/**
 * Column picker: always after a board is chosen for kanban projects;
 * for list projects, only when several placeable columns exist.
 */
export function shouldShowColumnPicker(
    project: PlaceableProject | null | undefined,
    boardId: string,
    placeableColumnCount: number,
): boolean {
    if (!boardId)
        return false;
    if (!prefersListLanding(project))
        return true;
    return placeableColumnCount > 1;
}
